import {
    convertCurrencyFormatPositiveNegative,
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    showErrorMessage,
    showSuccessMessage,
    RaikoTableTitleContainer,
    RaikoButtonPrimary,
    RaikoButtonSecondary,
    RaikoDefaultDialogPage,
    DialogSize, RaikoConfirmDialog, RaikoFlexAlignEnd
} from "@moeindal/base-raiko-panel-components";
import {useAuthState} from "../../../context/AuthContext";
import {useParams} from "react-router-dom";
import {LoanRequestsService} from "../../../serverService/loanRequests/LoanRequestsService";
import React, {useEffect, useState} from "react";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import RaikoCardInfoTypeOne, {
    RaikoCardInfoTypeOneItemGenerator, RaikoCardInfoTypeOneStatusTypes
} from "../../../raikoComponents/raikoCardInfo/RaikoCardInfoTypeOne";
import {Skeleton} from "@mui/lab";
import {css} from "@emotion/css";
import AccountDetailLoanInfo from "../../accounts/detail/AccountDetailLoanInfo";
import LoanRequestDetailSubmit from "./LoanRequestDetailSubmit";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function LoanRequestDetailBasicInfo() {

    const {fundID} = useAuthState()
    const {id: loanRequestId} = useParams()

    const service = new LoanRequestsService()

    const loading = new LoadingHelper(useLoadingDispatcher())

    const [basicInfo, setBasicInfo] = useState({
        acceptedAmount: "",
        acceptedLoanKind: "",
        acceptedNumberOfInstallments: 0,

        depositAccountId: null,

        depositAccountStatusAtSendTime: "",
        IBAN: "",
        ibanOwner: "",
        bankAccountNumber: "",
        depositAccountNumber: "",
        id: 0,
        numberOfLoans: 0,
        numberOfMonthsOfWaitingAtSubmitTime: 0,
        numberOfMonthsOfWaitingAtThisTime: 0,
        ownerFirstName: "",
        ownerLastName: "",
        requestedAmount: 0,
        requestedLoanKind: "",
        requestedNumberOfInstallments: 0,
        requesterFirstName: "",
        requesterLastName: "",
        sendAt: "",
        status: ""
    })
    const [basicInfoLoading, setBasicInfoLoading] = useState(true);

    useEffect(() => {
        getRequestDetail()
    }, [fundID]);

    function getRequestDetail() {
        setBasicInfoLoading(true)
        service.getLoanRequestBasicInfo(
            fundID,
            loanRequestId
        ).then(response => {
            setBasicInfo(response)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setBasicInfoLoading(false)
        })
    }


    const [submitDialog, setSubmitDialog] = useState(false);
    const openSubmitCode = () => setSubmitDialog(true)
    const closeSubmitCode = () => setSubmitDialog(false)


    function handleRejectLoanRequest() {
        loading.show()
        service.rejectLoanRequest(fundID, basicInfo.id)
            .then(response => {

                setBasicInfo({
                    ...basicInfo,
                    status: "REJECTED"
                })

                showSuccessMessage("درخواست وام با موفقیت رد شد.")
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleCloseDialogAfterCreateLoan() {
        closeSubmitCode()
        setBasicInfo({
            ...basicInfo,
            status: "ACCEPTED"
        })
    }

    const [rejectConfirmDialogState, setRejectConfirmDialogState] = useState(false);
    const openRejectConfirmDialog = () => setRejectConfirmDialogState(true)
    const closeRejectConfirmDialog = () => setRejectConfirmDialogState(false)
    return (
        <>
            <RaikoConfirmDialog
                cancelAction={closeRejectConfirmDialog}
                openConfirmDialog={rejectConfirmDialogState}
                doAction={handleRejectLoanRequest}
                pageTitle={"رد درخواست وام"}
                confirmButtonTitle={"رد درخواست"}
                warningTitle={"آیا از رد درخواست کاربر اطمینان دارید؟"}
                warningDescription={"با رد درخواست امکان ویرایش مجدد درخواست وجود نخواهد داشت."}
                cancelButtonTitle={"انصراف"}
            />

            <RaikoDefaultDialogPage
                onClose={closeSubmitCode}
                open={submitDialog}
                pageTitle={"ثبت وام"}
                dialogSize={DialogSize.LARGE}>
                <LoanRequestDetailSubmit
                    loanDefaultAmount={basicInfo.requestedAmount}
                    loanDefaultInstallments={basicInfo.requestedNumberOfInstallments}
                    accountId={basicInfo.depositAccountId}
                    handleCreateLoan={handleCloseDialogAfterCreateLoan}
                />
            </RaikoDefaultDialogPage>
            <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        {
                            basicInfoLoading ?
                                <Skeleton variant="rectangular" className={css`padding: 150px`}/>
                                :
                                <RaikoCardInfoTypeOne
                                    title={`جزئیات درخواست`}
                                    status={true}
                                    statusText={
                                        basicInfo.status === "ACCEPTED" ? "پذیرفته شده" :
                                            basicInfo.status === "CANCELLED" ? "لغو شده" :
                                                basicInfo.status === "REJECTED" ? "رد شده" : "در دست بررسی"
                                    }
                                    statusType={
                                        basicInfo.status === "ACCEPTED" ? RaikoCardInfoTypeOneStatusTypes.SUCCESS :
                                            basicInfo.status === "CANCELLED" ? RaikoCardInfoTypeOneStatusTypes.ERROR :
                                                basicInfo.status === "REJECTED" ? RaikoCardInfoTypeOneStatusTypes.ERROR :
                                                    RaikoCardInfoTypeOneStatusTypes.WARNING}
                                    items={[
                                        RaikoCardInfoTypeOneItemGenerator("شناسه درخواست", basicInfo.id),
                                        RaikoCardInfoTypeOneItemGenerator("مالک حساب", `${basicInfo.ownerFirstName} ${basicInfo.ownerLastName}`),
                                        RaikoCardInfoTypeOneItemGenerator("شماره حساب", basicInfo.depositAccountNumber),
                                        RaikoCardInfoTypeOneItemGenerator("درخواست دهنده", `${basicInfo.requesterFirstName} ${basicInfo.requesterLastName}`),
                                        RaikoCardInfoTypeOneItemGenerator("تاریخ درخواست", convertUniversalDateTimeToPersianDateTime(basicInfo.sendAt)),
                                        RaikoCardInfoTypeOneItemGenerator("نوع وام", basicInfo.requestedLoanKind),
                                        RaikoCardInfoTypeOneItemGenerator("مبلغ وام (ریال)", convertCurrencyFormatPositiveNegative(basicInfo.requestedAmount)),
                                        RaikoCardInfoTypeOneItemGenerator("تعداد اقساط", basicInfo.requestedNumberOfInstallments),
                                        RaikoCardInfoTypeOneItemGenerator("تعداد وام ها", basicInfo.numberOfLoans),
                                        RaikoCardInfoTypeOneItemGenerator("وضعیت حساب کاربر", basicInfo.depositAccountStatusAtSendTime),
                                        RaikoCardInfoTypeOneItemGenerator("ماه انتظار ثبت", basicInfo.numberOfMonthsOfWaitingAtSubmitTime ? basicInfo.numberOfMonthsOfWaitingAtSubmitTime : 0),
                                        RaikoCardInfoTypeOneItemGenerator("ماه انتظار کنونی", basicInfo.numberOfMonthsOfWaitingAtThisTime ? basicInfo.numberOfMonthsOfWaitingAtThisTime : 0),
                                        RaikoCardInfoTypeOneItemGenerator("شماره شبا واریز", basicInfo.IBAN ? basicInfo.IBAN : "-"),
                                        RaikoCardInfoTypeOneItemGenerator("مالک حساب", basicInfo.ibanOwner ? basicInfo.ibanOwner : "-"),
                                        RaikoCardInfoTypeOneItemGenerator("شماره حساب واریز", basicInfo.bankAccountNumber ? basicInfo.bankAccountNumber : "-"),
                                    ]}
                                    hasBottomChildren={basicInfo.status === "AWAITING_FOR_REVIEW"}
                                >
                                    <RaikoFlexAlignEnd>
                                        <RaikoButtonSecondary
                                            label={"رد درخواست وام"}
                                            onClick={openRejectConfirmDialog}/>
                                        <RaikoButtonPrimary
                                            label={"ثبت وام"}
                                            onClick={openSubmitCode}/>
                                    </RaikoFlexAlignEnd>
                                </RaikoCardInfoTypeOne>
                        }
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>

                {
                    !basicInfoLoading && basicInfo.status === "ACCEPTED" ?
                        <RaikoBaseCardContainer>
                            <RaikoCardInfoTypeOne
                                title={`جزئیات پرداخت`}
                                items={[
                                    RaikoCardInfoTypeOneItemGenerator("مبلغ (ریال)", convertCurrencyFormatPositiveNegative(basicInfo.acceptedAmount)),
                                    RaikoCardInfoTypeOneItemGenerator("تعداد اقساط", basicInfo.acceptedNumberOfInstallments),
                                    RaikoCardInfoTypeOneItemGenerator("نوع وام", basicInfo.acceptedLoanKind),
                                ]
                                }
                            />
                        </RaikoBaseCardContainer>
                        : ""
                }

                <AccountDetailLoanInfo
                    accountId={basicInfo.depositAccountId}
                    basicLoading={basicInfoLoading && basicInfo.depositAccountId > 0}
                />

            </RaikoGridOneColumn>
        </>
    )
}
